const STAGE_STYLES = {
  Prospect: "text-slate-500",
  Draft: "text-slate-500",
  Submitted: "text-[#1F2937]",
  "Initial Review": "text-[#1F2937]",
  Assigned: "text-[#1F2937]",
  Underwriting: "text-[#1F2937]",
  "Conditional Approval": "text-[#1F2937]",
  "Need Additional Documents": "text-[#1F2937]",
  Approved: "text-[#1F2937]",
  Funded: "text-[#1F2937]",
  Declined: "text-[#1F2937]",
};

export default function StagePill({ stage }) {
  const cls = STAGE_STYLES[stage] || "text-slate-500";
  return (
    <span className={`inline-flex items-center gap-2 small-caps ${cls}`} data-testid={`stage-pill-${(stage||'').toLowerCase().replace(/\s+/g,'-')}`}>
      <span className="h-[6px] w-[6px] rounded-full bg-current opacity-70" />
      {stage}
    </span>
  );
}

export const LOAN_STAGES = [
  "Prospect","Draft","Submitted","Initial Review","Assigned","Underwriting",
  "Conditional Approval","Need Additional Documents","Approved","Funded","Declined",
];
